import React, { FC } from 'react';
import { Divider } from 'wix-ui-tpa';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';

import { DataHook } from '../../../../types';
import { useMember } from '../../../../contexts/widgets';
import settingsParams from '../../settingsParams';
import SectionTitle from '../common/SectionTitle';
import StatisticalUnit from './StatisticalUnit';
import About from './About';
import { useAboutRendered, useNumbersVisibility } from './hooks';
import { classes } from './Description.st.css';

export const Description: FC = () => {
  const settings = useSettings();
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { numbers } = useMember();
  const { shouldRenderAbout } = useAboutRendered();
  const numbersVisibility = useNumbersVisibility();
  const shouldRenderStats = Object.values(numbersVisibility).some(Boolean);

  return (
    <>
      <SectionTitle>
        {settings.get(settingsParams.aboutSectionTitle)}
      </SectionTitle>
      {shouldRenderStats && (
        <div className={classes.statsContainer}>
          {numbersVisibility.showLikesReceivedStats && (
            <StatisticalUnit
              dataHook={DataHook.LikesReceivedStats}
              className={classes.statisticalUnit}
              titleSingular={t('profile-stats-like-received')}
              titlePlural={t('profile-stats-likes-received')}
              tooltipText={t('profile-stats-likes-received-tooltip')}
              count={numbers.likesReceived}
              isMobile={isMobile}
            />
          )}
          {numbersVisibility.showCommentsStats && (
            <StatisticalUnit
              dataHook={DataHook.CommentsStats}
              className={classes.statisticalUnit}
              titleSingular={t('profile-stats-comment')}
              titlePlural={t('profile-stats-comments')}
              tooltipText={t('profile-stats-comments-tooltip')}
              count={numbers.commentsReceived}
              isMobile={isMobile}
            />
          )}
          {numbersVisibility.showTopCommentsStats && (
            <StatisticalUnit
              dataHook={DataHook.TopCommentsStats}
              className={classes.statisticalUnit}
              titleSingular={t('profile-stats-top-comment')}
              titlePlural={t('profile-stats-top-comments')}
              tooltipText={t('profile-stats-top-comments-tooltip')}
              count={numbers.topCommentsCount}
              isMobile={isMobile}
            />
          )}
        </div>
      )}
      {shouldRenderStats && shouldRenderAbout && !isMobile && (
        <Divider className={classes.divider} />
      )}
      {shouldRenderAbout && <About />}
    </>
  );
};
